/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { TaskInstanceView } from './TaskInstanceView';
import {
    TaskInstanceViewFromJSON,
    TaskInstanceViewFromJSONTyped,
    TaskInstanceViewToJSON,
    instanceOfTaskInstanceView,
} from './TaskInstanceView';

/**
 * 
 * @export
 * @interface GetSimulatedTaskResponseContent
 */
export interface GetSimulatedTaskResponseContent {
    /**
     * 
     * @type {TaskInstanceView}
     * @memberof GetSimulatedTaskResponseContent
     */
    task: TaskInstanceView;
}


/**
 * Check if a given object implements the GetSimulatedTaskResponseContent interface.
 */
export function instanceOfGetSimulatedTaskResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "task" in value;
    return isInstance;
}

export function GetSimulatedTaskResponseContentFromJSON(json: any): GetSimulatedTaskResponseContent {
    return GetSimulatedTaskResponseContentFromJSONTyped(json, false);
}

export function GetSimulatedTaskResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSimulatedTaskResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'task': TaskInstanceViewFromJSON(json['task']),
    };
}

export function GetSimulatedTaskResponseContentToJSON(value?: GetSimulatedTaskResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'task': TaskInstanceViewToJSON(value.task),
    };
}

